module.exports = __webpack_public_path__ + "static/img/sunwoo-safety-leadership.4ca566e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/sunwoo-safety-leadership.jpg
// module id = Dhi2
// module chunks = 0